var _rect, _path, _line, _line2, _line3, _line4, _rect2, _path2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 50.3931,
    width: 134.908,
    height: 95.0213,
    rx: 7,
    fill: "#EDF0F3",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5488 66.0171C43.5488 62.1511 46.6828 59.0171 50.5488 59.0171H156.364C160.23 59.0171 163.364 62.1511 163.364 66.0171V128.166H43.5488V66.0171Z",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 128.167,
    x2: 170.83,
    y2: 128.167,
    stroke: "#787E8C",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 79.1973,
    y1: 166.975,
    x2: 128.786,
    y2: 166.975,
    stroke: "#787E8C",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 89.8965,
    y1: 145.336,
    x2: 89.8965,
    y2: 166.897,
    stroke: "#787E8C",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 116.85,
    y1: 145.336,
    x2: 116.85,
    y2: 166.897,
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94.83,
    y: 136.173,
    width: 17.2482,
    height: 1.07801,
    rx: 0.539007,
    stroke: "#787E8C",
    strokeWidth: 1.07801
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1798 27.8082C100.45 23.6198 106.461 23.6198 108.73 27.8082L146.922 98.2862C149.089 102.284 146.194 107.145 141.647 107.145H65.2631C60.716 107.145 57.8214 102.284 59.9878 98.2862L98.1798 27.8082Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6035,
    y: 49.3149,
    width: 7.70213,
    height: 29.2624,
    rx: 3.85106,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6035,
    y: 89.2017,
    width: 7.70213,
    height: 7.70213,
    rx: 3.85106,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionError);
export default __webpack_public_path__ + "static/media/connection-error.a4aed5078c463543b93d49db453bec94.svg";
export { ForwardRef as ReactComponent };